import React, { useState, useEffect, useRef, useContext } from 'react';
import { Container, Row, Col, Card as BootstrapCard, CardBody } from 'react-bootstrap';
import { AlertOctagon } from 'react-feather';
import { Button } from 'reactstrap';
import { IoCheckmarkOutline } from 'react-icons/io5';
import { RxReset } from 'react-icons/rx';
import { RiMenu5Line } from 'react-icons/ri';
import { X } from 'react-feather';
import Card from './Card';
import DryRunModal from './DryRunModal';
import ImageZoom from '../../../../ImageZoom';
import AreaService from '../../../../../api/areaService';
import { getCurrentWeekWithYear } from '../../../../../utils/currentWeekWithYear';
import Loader3 from '../../../../../CommonElements/Spinner/loader3';
import LiveAlertsFilters from '../../../AreaDashbaord/reports/Components/DateFilters/LiveAlertsFilters';
import { ViolationSeverity } from '../../../../../Data/staticData/data';
import { errorToast, successToast } from '../../../../../_helper/helper';
import { getSharedFilters, updateSharedFilters } from '../../../../../utils/filters/shareFilters';
import { getProductIdByName } from '../../../../../utils/getProductID';
import { getAreaIdsOfAreaOwner } from '../../../../../utils/helpers';
import CameraService from '../../../../../api/cameraService';
import TypeheadFilter from '../../../../Common/commonFilterButton/TypeheadFilter';
import axios from 'axios';
import FalseAlertFilters from '../../../AreaDashbaord/reports/Components/DateFilters/FalseAlertFilters';
import DynamicModulesContext from "../../../../../_helper/formData/DynamicModules/DynamicModulesContext";


const FalseAlert = () => {
  //time formatting
  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${year}-${month}-${day} ${hours}:${minutes}${ampm}`;
  }
  const normalizeAlertId = (value, fallback = '') => {
    const normalizedValue = value ?? fallback;
    if (normalizedValue === null || normalizedValue === undefined || normalizedValue === '') {
      return '';
    }
    return String(normalizedValue);
  };

  const getAlertId = (alert, fallback = '') => normalizeAlertId(alert?.operation_safety_id, fallback);

  /** Prefer unannotated URL; many get_live_alerts payloads only populate `image`. */
  const getAlertImageUrl = (alert) =>
    alert?.unannotated_image || alert?.image || '/assets/images/warehouse_cctv.png';

  const { AllActiveModules, setAllActiveModules } = useContext(DynamicModulesContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalAlerts, setTotalAlerts] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageCache, setPageCache] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [showCamButton, setShowCamButton] = useState(false);
  const [callApi, setCallApi] = useState(false);
  const [modules, setModules] = useState();
  const [initialMods, setInitialMods] = useState();
  const [severities, setSeverities] = useState(ViolationSeverity);
  const [areas, setAreas] = useState([]);
  const [subareas, setSubAreas] = useState({});
  const [cameras, setCameras] = useState([]);
  const [selectedCards, setSelectedCards] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [loadingBatches, setLoadingBatches] = useState(false);
  const [transferring, setTransferring] = useState(false);
  const [allAlertIds, setAllAlertIds] = useState([]);
  const [loadingAllAlerts, setLoadingAllAlerts] = useState(false);
  const [allAlertsData, setAllAlertsData] = useState({});
  const [showDryRunModal, setShowDryRunModal] = useState(false);
  const [dryRunData, setDryRunData] = useState(null);
  const [dryRunning, setDryRunning] = useState(false);
  const [showBatchDropdown, setShowBatchDropdown] = useState(false);
  const [showImageZoom, setShowImageZoom] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const filterCardRef = useRef(null);
  const filterButton = useRef(null);
  const batchDropdownRef = useRef(null);

  const role = JSON.parse(localStorage.getItem('role'));
  const userData = JSON.parse(localStorage.getItem('userData'));
  const factoryID = userData?.factory?.id || 0;
  const currentWeek = getCurrentWeekWithYear();
  const shared = getSharedFilters();
  const areaDashboardTrue = role === 'area';

  const [selectedOption, setSelectedOption] = useState('Week');
  const [dateShow, setDateShow] = useState(false);
  const [monthShow, setMonthShow] = useState(false);
  const [weeklyShow, setWeeklyShow] = useState(true);
  const [customDate, setCustomDate] = useState(false);

  const style = {
    minWidth: "150px",
    width: "144px",
    maxWidth: "150px",
    height: "38px",
    fontSize: 13,
  };

  const typeheadStyle = {
    minWidth: "155px",
    fontSize: "13px",
    color: "black",
  };

  const getInitialFilters = () => {
    const savedFilters = localStorage.getItem('falseAlertFilters');
    return savedFilters
      ? JSON.parse(savedFilters)
      : {
          camera_id: [],
          module: '',
          severity: '',
          shift: shared.shift ? [shared.shift] : [],
          date: '',
          week: shared.weekly || currentWeek,
          month: shared.month || '',
          starting: '',
          ending: '',
          area: '',
          subarea: '',
          acknowledge: '',
          approval: 'Rejected',
        };
  };

  const [newFilters, setNewFilters] = useState(getInitialFilters);

  useEffect(() => {
    const updatedFil = {
      weekly: newFilters?.week,
      month: newFilters?.month,
      shift: newFilters?.shift?.length > 0 ? newFilters?.shift[0] : "",
    };
    updateSharedFilters(updatedFil);
  }, [newFilters]);

  useEffect(() => {
    fetchModules();
    fetchArea();
    fetchBatches();
  }, []);

  useEffect(() => {
    let filters = JSON.parse(localStorage.getItem("falseAlertFilters"));
    if (!filters) {
      localStorage.setItem("falseAlertFilters", JSON.stringify(newFilters));
    } else {
      setNewFilters(filters);
    }

    if (newFilters?.camera_id.length > 0) {
      setShowCamButton(true);
    } else {
      setShowCamButton(false);
    }

    if (
      filters?.module!='' ||
      filters?.severity !== '' ||
      (role !== 'area' && filters?.area !== '') ||
      filters?.subarea !== '' ||
      filters?.month !== '' ||
      filters?.date !== '' ||
      filters?.week !== currentWeek ||
      filters?.starting !== '' ||
      filters?.ending !== '' ||
      filters?.camera_id.length > 0
    ) {
      setShowButtons(true);
    } else {
      setShowButtons(false);
    }

    if (filters?.month !== '') {
      setMonthShow(true);
      setDateShow(false);
      setWeeklyShow(false);
      setCustomDate(false);
      setSelectedOption('Month');
    } else if (filters?.date !== '') {
      setMonthShow(false);
      setDateShow(true);
      setWeeklyShow(false);
      setCustomDate(false);
      setSelectedOption('Daily');
    } else if (filters?.starting !== '' || filters?.ending !== '') {
      setMonthShow(false);
      setDateShow(false);
      setWeeklyShow(false);
      setCustomDate(true);
      setSelectedOption('Custom');
    } else if (filters?.week !== currentWeek) {
      setMonthShow(false);
      setDateShow(false);
      setWeeklyShow(true);
      setCustomDate(false);
      setSelectedOption('Week');
    }

    if (!pageCache[pageNo]) {
      fetchFalseAlerts(filters || newFilters, true);
    } else {
      setData(pageCache[pageNo]);
    }
  }, [pageNo, callApi]);

  useEffect(() => {
    getCameras(newFilters);
  }, [newFilters?.area, newFilters?.subarea, newFilters?.modules_ids]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        filterCardRef.current &&
        filterButton.current &&
        !filterCardRef.current.contains(event.target) &&
        !filterButton.current.contains(event.target)
      ) {
        setShowFilters(false);
      }
      
      if (
        batchDropdownRef.current &&
        !batchDropdownRef.current.contains(event.target)
      ) {
        setShowBatchDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilters, showBatchDropdown]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pageNo]);

  const fetchFalseAlerts = async (filters, loading) => {
    try {
      if (loading) {
        setLoading(true);
      }
      setError(null);

      const payload = {
        user_id: userData?.id || 1,
        factory_id: factoryID,
        role: role,
        identifier:
          filters?.date !== ''
            ? 'date'
            : filters?.week !== ''
            ? 'week'
            : filters?.month !== ''
            ? 'month'
            : filters?.starting !== '' && filters?.ending !== ''
            ? 'custom'
            : 'week',
        filters: {
          approval: filters?.approval || 'Rejected',
          // camera_id: filters?.camera_id || [],
          status: 'rejected', // Always filter for rejected alerts (false alerts)
          module: filters?.module ,
          severity: filters?.severity || '',
          shift: filters?.shift?.length > 0 ? filters?.shift[0] : '',
          date: filters?.date || '',
          week: filters?.week || '',
          month: filters?.month || '',
          starting: filters?.starting || '',
          ending: filters?.ending || '',
          ...(filters?.starting && filters?.ending
            ? { customDate: { starting: filters.starting, ending: filters.ending } }
            : {}),
          area: areaDashboardTrue ? getAreaIdsOfAreaOwner() : filters?.area ,
          // subarea: filters?.subarea || '',
          acknowledge: filters?.acknowledge || '',
           shift_ids: [],
        ...(role === 'incharge' || role === 'supervisor' || role === 'checker')
          ? {
              camera_id: userData?.camera_ids?.map((item) => item) || [],
              subarea: userData?.sub_area_ids?.map((item) => item) || [],
            }
          : {
              camera_id: filters?.camera_id || [],
              subarea: filters?.subarea 
            },
        location: '',
        },
        pagination: {
          page_no: pageNo,
          per_page: 21,
        },
        // ...(role === 'aitechqa' && { aitechqa: 'rejected' }),
        // client_id: userData?.client?.id || 0,
        
        
       
      };

      const res = await AreaService.getFilterAlerts(payload);

      if (res?.data?.data?.alerts) {
        const alerts = res.data.data.alerts;

        const formattedAlerts = alerts.map((alert, index) => ({
          id: getAlertId(alert, `false-alert-${pageNo}-${index}`),
          alertType: alert.module || 'Unknown Alert',
          severity: alert.severity || 'Medium',
          cameraId: alert.camera_id || '',
          cameraName: alert.camera_name || 'Unknown Camera',
          location: `${alert.area || ''}, ${alert.subarea || ''}`.trim() || 'Unknown Location',
          timestamp: `${alert.date || ''}, ${alert.time || ''}`,
          LSR: alert.lsr || 'False positive detected',
          reportedBy: alert.verified_by || 'AI-Tech QA',
          image: getAlertImageUrl(alert),
        }));

        setPageCache((prevCache) => ({
          ...prevCache,
          [pageNo]: formattedAlerts,
        }));

        setData(formattedAlerts);
        setTotalAlerts(res.data.data.total_records || formattedAlerts.length);
        setTotalPages(res.data.data.total_pages);
      }
    } catch (err) {
      console.error('Error fetching false alerts:', err);
      setError(err.message || 'Failed to fetch false alerts');
    } finally {
      setLoading(false);
    }
  };

  async function fetchModules() {
    // const id = userData?.factory?.id;
    // const p_id = getProductIdByName(JSON.parse(localStorage.getItem('selectedProduct')).toLowerCase());
    const res = await AreaService.GetModules();
          // console.log("getting modules", res?.data?.data);
          // const update = factoryID==14 ? res?.data?.data.filter(item => item.module_name!=='No Go Area') : res?.data?.data
          const FactoryModules = AllActiveModules || []
          const filteredModules = res?.data?.data?.filter(item => FactoryModules.includes(item.module_name))
          console.log('fitlered modules', filteredModules)
          setModules(filteredModules);
    setInitialMods(filteredModules?.map((m) => m.module_name));
  }

  async function fetchArea() {
    try {
      const res = await AreaService.GetAllAreas(factoryID);
      setAreas(res?.data?.data?.areas);
      const mappedAreas =
        res?.data?.data?.areas &&
        res?.data?.data?.areas.map((area) => ({
          ...area,
          label: `${area.area}, ${area.areaOwner}`,
          disabled: !area.active,
        }));

       

      const subs = mappedAreas.reduce((acc, a) => {
        acc[a.area] = a.sub_area;
        return acc;
      }, {});
       console.log('mapped areas', subs)
      setSubAreas(subs);
    } catch (error) {
      console.log(error);
      errorToast('Error while fetching areas');
    }
  }

  async function getCameras(filtersOverride) {
    const filters = filtersOverride || JSON.parse(localStorage.getItem('falseAlertFilters'));

    // const payload = {
    //   client_id: userData?.client.id,
    //   factory_id: factoryID,
    //   area_ids: areaDashboardTrue
    //     ? getAreaIdsOfAreaOwner()
    //     : filters?.area?.id
    //     ? [filters.area.id]
    //     : [],
    //   sub_area_ids: filters?.subarea?.id ? [filters.subarea.id] : [],
    //   device_id: 1,
    //   active: true,
    //   modules: parseInt(filters?.modules_ids) ? [parseInt(filters.modules_ids)] : [],
    // };

    const factory = JSON.parse(localStorage.getItem('userData'))?.factory?.name
const payload = {
  factory_name: factory
}
    const res = await CameraService.getAllCamerasForSync(payload);
    const cams = res?.data?.data.map((cam) => cam.camera_mapping_id);
    setCameras(cams);
  }

  async function fetchBatches() {
    try {
      setLoadingBatches(true);
      const res = await axios.get('https://besafetylens.disruptlabs.tech/annotation/get_all_yolo_classes')
      if (res?.data?.success) {
        // Filter batches by factory ID
        const factoryBatches = res.data.data.filter(
          (batch) => batch.factory_id === 2
        );
        setBatches(factoryBatches);
      }
    } catch (error) {
      console.error('Error fetching batches:', error);
      errorToast('Failed to fetch batches');
    } finally {
      setLoadingBatches(false);
    }
  }

  const handleSelectAll = async () => {
    const filters = JSON.parse(localStorage.getItem('falseAlertFilters')) || newFilters;
    
    try {
      setLoadingAllAlerts(true);
      
      const payload = {
        user_id: userData?.id || 1,
        factory_id: factoryID,
        role: role,
        identifier:
          filters?.date !== ''
            ? 'date'
            : filters?.week !== ''
            ? 'week'
            : filters?.month !== ''
            ? 'month'
            : filters?.starting !== '' && filters?.ending !== ''
            ? 'custom'
            : 'week',
        filters: {
          approval: filters?.approval || 'Rejected',
          status: 'rejected',
          module: filters?.module,
          severity: filters?.severity || '',
          shift: filters?.shift?.length > 0 ? filters?.shift[0] : '',
          date: filters?.date || '',
          week: filters?.week || '',
          month: filters?.month || '',
          starting: filters?.starting || '',
          ending: filters?.ending || '',
          ...(filters?.starting && filters?.ending
            ? { customDate: { starting: filters.starting, ending: filters.ending } }
            : {}),
          area: areaDashboardTrue ? getAreaIdsOfAreaOwner() : filters?.area,
          subarea:
            role === 'incharge' || role === 'supervisor' || role === 'checker'
              ? userData?.sub_area_ids?.map((item) => item) || []
              : filters?.subarea,
          acknowledge: filters?.acknowledge || '',
          shift_ids: [],
          ...(role === 'incharge' || role === 'supervisor' || role === 'checker')
            ? {
                camera_id: userData?.camera_ids?.map((item) => item) || [],
              }
            : {
                camera_id: filters?.camera_id || [],
              },
          location: '',
        },
        pagination: {
          page_no: 1,
          per_page: totalAlerts || 10000, // Get all records
        },
      };

      const res = await AreaService.getFilterAlerts(payload);

      if (res?.data?.data?.alerts) {
        const alerts = res.data.data.alerts;
        const allIds = alerts
          .map((alert, index) => getAlertId(alert, `false-alert-selectall-${index}`))
          .filter((id) => id !== null && id !== undefined && id !== '');
        
        // Store complete alert data in a map for easy lookup
        const alertsMap = {};
        alerts.forEach((alert, index) => {
          const alertId = getAlertId(alert, `false-alert-selectall-${index}`);
          if (alertId === null || alertId === undefined || alertId === '') return;

          alertsMap[alertId] = {
            id: alertId,
            alertType: alert.module_name || 'Unknown Alert',
            severity: alert.severity || 'Medium',
            cameraId: alert.camera_id || '',
            cameraName: alert.camera_name || 'Unknown Camera',
            location: `${alert.area_name || ''}, ${alert.sub_area_name || ''}`.trim() || 'Unknown Location',
            timestamp: formatDateTime(alert.timestamp) || new Date().toISOString(),
            LSR: alert.lsr || 'False positive detected',
            reportedBy: alert.verified_by || 'System',
            image: getAlertImageUrl(alert),
          };
        });
        
        setAllAlertsData(alertsMap);
        setAllAlertIds(allIds);
        setSelectedCards(allIds);
      } else {
        errorToast('No alerts found to select');
      }
    } catch (error) {
      console.error('Error fetching all alert IDs:', error);
      errorToast(error?.response?.data?.message || error?.message || 'Failed to fetch all alerts');
    } finally {
      setLoadingAllAlerts(false);
    }
  };

  const handleDeselectAll = () => {
    setSelectedCards([]);
    setAllAlertIds([]);
    setAllAlertsData({});
    setSelectedBatch([]);
  };

  const handleCardSelect = (alertId, isSelected) => {
    const normalizedAlertId = normalizeAlertId(alertId);

    // Ignore invalid IDs so one bad API record can't toggle all cards
    if (!normalizedAlertId) {
      return;
    }

    if (isSelected) {
      setSelectedCards((prev) => (prev.includes(normalizedAlertId) ? prev : [...prev, normalizedAlertId]));
    } else {
      setSelectedCards((prev) => prev.filter((id) => id !== normalizedAlertId));
    }
  };

  // Helper function to remove query parameters from URL
  const removeUrlQueryParams = (url) => {
    if (!url) return '';
    try {
      const urlObj = new URL(url);
      return `${urlObj.origin}${urlObj.pathname}`;
    } catch (error) {
      // If URL parsing fails, try simple string manipulation
      return url.split('?')[0];
    }
  };

  const handleTransferImages = async (isDryRun = false) => {
    if (!selectedBatch || selectedBatch.length === 0) {
      errorToast('Please select at least one batch to transfer images');
      return;
    }

    if (selectedCards.length === 0) {
      errorToast('No cards selected');
      return;
    }

    try {
      if (isDryRun) {
        setDryRunning(true);
      } else {
        setTransferring(true);
      }

      // Build the images array from selected cards
      const images = selectedCards.map((alertId) => {
        // First check allAlertsData (from Select All), then current page data, then pageCache
        let alert = allAlertsData[alertId] || 
                   data.find((a) => a.id === alertId) || 
                   Object.values(pageCache).flat().find((a) => a.id === alertId);
        console.log('alert', alert)
        return {
          camera_id: alert?.cameraId || '',
          client_id: userData?.client?.id || 1,
          factory_id: 2,
          batch_ids: selectedBatch.map(id => parseInt(id)),
          image_url: alert?.image || ''
        };
      });

      const payload = {
        images: images,
        dry_run: isDryRun
      };

      const response = await axios.post('https://besafetylens.disruptlabs.tech/annotation/insert_false_alert_images_batch_wise', payload);

      if (response?.data) {
        if (isDryRun) {
          // Show dry run modal with results
          setDryRunData(response.data);
          setShowDryRunModal(true);
        } else {
          // Show success message and reset
          successToast(response.data.message || `Successfully transferred ${selectedCards.length} images to ${selectedBatch.length} batch(es)`);
          handleDeselectAll();
          setShowDryRunModal(false);
          setDryRunData(null);
          // Refresh the data
          setCallApi((prev) => !prev);
        }
      }
    } catch (error) {
      console.error('Error transferring images:', error);
      errorToast(error?.response?.data?.message || 'Failed to transfer images');
    } finally {
      setDryRunning(false);
      setTransferring(false);
    }
  };

  const handleBatchToggle = (batchId) => {
    setSelectedBatch((prev) => {
      if (prev.includes(batchId)) {
        return prev.filter((id) => id !== batchId);
      } else {
        return [...prev, batchId];
      }
    });
  };

  const handleRemoveBatch = (batchId) => {
    setSelectedBatch((prev) => prev.filter((id) => id !== batchId));
  };

  const getSelectedBatchDetails = () => {
    return batches.filter((batch) => selectedBatch.includes(batch.batch_id));
  };

  const handleDryRun = () => {
    handleTransferImages(true);
  };

  const handleActualTransfer = () => {
    handleTransferImages(false);
  };

  const handleImageClick = (alert) => {
    setSelectedImage({
      photo: alert.image,
      cameraName: alert.cameraName,
      violation: alert.alertType,
      date: alert.timestamp,
      LSR: alert.LSR,
      location: alert.location,
      reportedBy: alert.reportedBy,
    });
    setShowImageZoom(true);
  };

  const handleDateDrop = (e) => {
    setSelectedOption(e.target.value);
    setShowButtons(true);
    if (e.target.value === 'Duration') {
      setMonthShow(false);
      setDateShow(false);
      setWeeklyShow(false);
      setCustomDate(false);
    } else if (e.target.value === 'Month') {
      setMonthShow(true);
      setDateShow(false);
      setWeeklyShow(false);
      setCustomDate(false);
    } else if (e.target.value === 'Daily') {
      setMonthShow(false);
      setDateShow(true);
      setWeeklyShow(false);
      setCustomDate(false);
    } else if (e.target.value === 'Week') {
      setMonthShow(false);
      setDateShow(false);
      setWeeklyShow(true);
      setCustomDate(false);
    } else if (e.target.value === 'Custom') {
      setMonthShow(false);
      setDateShow(false);
      setWeeklyShow(false);
      setCustomDate(true);
    }
  };

  const handleTypeChange = (selected) => {
    setShowCamButton(true);
    setNewFilters((prevFilters) => ({
      ...prevFilters,
      camera_id: selected,
    }));
  };

  const handleNewInputChange = (e, field) => {
    let value = e.target.value;
    setShowButtons(true);

    if (field === 'week' && value) {  
      setNewFilters((prevFilters) => {
        const updatedFilters = {
          ...prevFilters,
          week: value,
          date: '',
          month: '',
          starting: '',
          ending: '',
        };
        localStorage.setItem('falseAlertFilters', JSON.stringify(updatedFilters));
        return updatedFilters;
      });
    } else if (field === 'month' && value) {
      setNewFilters((prevFilters) => {
        const updatedFilters = {
          ...prevFilters,
          month: value,
          date: '',
          week: '',
          starting: '',
          ending: '',
        };
        localStorage.setItem('falseAlertFilters', JSON.stringify(updatedFilters));
        return updatedFilters;
      });
    } else if (field === 'date' && value) {
      setNewFilters((prevFilters) => {
        const updatedFilters = {
          ...prevFilters,
          date: value,
          month: '',
          week: '',
          starting: '',
          ending: '',
        };
        localStorage.setItem('falseAlertFilters', JSON.stringify(updatedFilters));
        return updatedFilters;
      });
    } else if (field === 'starting' || field === 'ending') {
      setNewFilters((prevFilters) => {
        const updatedFilters = {
          ...prevFilters,
          [field]: value,
          date: '',
          month: '',
          week: '',
        };
        localStorage.setItem('falseAlertFilters', JSON.stringify(updatedFilters));
        return updatedFilters;
      });
    } else if (field === 'module') {
      const selectedModule = modules.find((m) => m?.module_name === value);
      console.log('selected module', value)
      setNewFilters((prevFilters) => {
        const updatedFilters = {
          ...prevFilters,
          module: value,
          selectedModule: selectedModule,
        };
        return updatedFilters;
      });
    } else if (field === 'area') {
      const selectedArea = areas?.find((a) => a.area === value);
      console.log('selected area', selectedArea)
      setNewFilters((prev) => ({
        ...prev,
        area: selectedArea.area,
        subarea: '',
      }));
    } else if (field === 'subarea') {
      const selectedSubarea = subareas[newFilters?.area]?.find((sub) => sub.name === value);
      console.log('selectedsubarea', selectedSubarea)
      setNewFilters((prev) => ({
        ...prev,
        subarea: selectedSubarea?.name,
      }));
    } else {
      setNewFilters((prevFilters) => {
        const updatedFilters = {
          ...prevFilters,
          [field]: value,
        };
        localStorage.setItem('falseAlertFilters', JSON.stringify(updatedFilters));
        return updatedFilters;
      });

      if (field === 'severity') {
        if (value === 'High') {
          const filteredModules = initialMods.filter((mod) => !['Vest', 'Helmet', 'Machine Guard'].includes(mod));
          setModules(filteredModules);
        } else if (value === 'Medium') {
          const filteredModules = initialMods.filter((mod) => !['Helmet', 'Emergency Exit', 'Vest', 'MMHE'].includes(mod));
          setModules(filteredModules);
        } else if (value === 'Medium plus') {
          const filteredModules = initialMods.filter((mod) => !['Emergency Exit', 'Machine Guard', 'MMHE'].includes(mod));
          setModules(filteredModules);
        } else {
          setModules(initialMods);
        }
      }
    }
  };

  const applyNewFilters = async () => {
    if (dateShow && newFilters.date === '') {
      errorToast('Choose The Date');
      return;
    } else if (weeklyShow && newFilters.week === '') {
      errorToast('Choose The Week');
      return;
    } else if (monthShow && newFilters.month === '') {
      errorToast('Choose The Month');
      return;
    } else if (customDate && (newFilters.starting === '' || newFilters.ending === '')) {
      errorToast('Choose Both ranges');
      return;
    }

    setLoading(true);
    setCallApi((prev) => !prev);
    if (pageNo !== 1) {
      setPageNo(1);
    }
    setPageCache({});
    localStorage.setItem('falseAlertFilters', JSON.stringify(newFilters));
  };

  function Reset() {
    setLoading(true);
    setShowButtons(false);
    setShowCamButton(false);
    setDateShow(false);
    setWeeklyShow(true);
    setMonthShow(false);
    setCustomDate(false);
    setSelectedOption('Week');
    setCallApi((prev) => !prev);
    if (pageNo !== 1) {
      setPageNo(1);
    }
    setPageCache({});

    const resetFilters = {
      camera_id: [],
      modules_ids: [],
      severity: '',
      shift: shared.shift ? [shared.shift] : [],
      module: '',
      date: '',
      week: shared.weekly || currentWeek,
      month: '',
      starting: '',
      ending: '',
      area: '',
      subarea: '',
      acknowledge: '',
      approval: 'Rejected',
    };

    setNewFilters(resetFilters);
    localStorage.setItem('falseAlertFilters', JSON.stringify(resetFilters));
    setSeverities(['High', 'Medium plus', 'Medium']);
  }

  if (loading) {
    return (
      <Container fluid className="px-3">
        <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(100vh - 200px)' }}>
          <Loader3 />
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid className="px-3">
        <div className="text-center p-5 text-danger">
          <h5>Error: {error}</h5>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="px-3 py-4">
      <Row className="mb-4">
        <Col xs={12}>
          <h4 className="mb-3">False Alert Management</h4>
        </Col>
      </Row>

      {/* Total Count Card with Select All Button */}
      <Row className="mb-4">
        <Col xs={12}>
          <BootstrapCard className="shadow-sm" style={{ borderTop: '4px solid #dc3545' }}>
            <CardBody>
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: '60px',
                      height: '60px',
                      backgroundColor: '#dc354520',
                    }}
                  >
                    <AlertOctagon size={32} color="#dc3545" />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total False Alerts</h6>
                    <h2 className="mb-0 fw-bold">{totalAlerts}</h2>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <div className="text-end me-3">
                    <small className="text-muted">
                      Applied Filter:
                       "{newFilters.week !== ''
                        ? `Week ${newFilters.week?.split('-W')[1]}`
                        : newFilters.date !== ''
                        ? `Day ${newFilters.date?.split('-')[2]}`
                        : newFilters.month !== ''
                        ? `${newFilters.month?.replace(/(\d{4})-(\d{1,2})/, (match, year, month) =>
                            ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][
                              parseInt(month, 10) - 1
                            ]
                          )} ${newFilters.month?.split('-')[0].slice(-2)}`
                        : newFilters.starting && newFilters.ending && `${newFilters.starting} to ${newFilters.ending}`}"
                    </small>
                  </div>
                  {selectedCards.length > 0 ? (
                    <Button
                      color="danger"
                      size="sm"
                      onClick={handleDeselectAll}
                      className="d-flex align-items-center gap-2"
                    >
                      Clear all {selectedCards.length} cards
                    </Button>
                  ) : (
                    <Button
                      color="primary"
                      size="sm"
                      onClick={handleSelectAll}
                      disabled={data.length === 0 || loadingAllAlerts}
                      className="d-flex align-items-center gap-2"
                    >
                      {loadingAllAlerts ? 'Loading...' : `Select All (${totalAlerts})`}
                    </Button>
                  )}
                </div>
              </div>
            </CardBody>
          </BootstrapCard>
        </Col>
      </Row>

      {/* Filters Section */}
      <Row className="mb-3">
        <Col xs={12} className="d-flex justify-content-end">
          <div
            type="button"
            className={`d-flex justify-content-center filter-btnn ${showFilters && 'border_R'}`}
            ref={filterButton}
            onClick={() => setShowFilters(!showFilters)}
            style={{
              backgroundColor: '#fff',
              border: '1px solid #e0e0e0',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            <p className="m-0" style={{ fontSize: '16px', color: '#000' }}>
              Filters
            </p>
            <span className="d-flex">
              <RiMenu5Line color="#8c8c8c" size={16} className="ms-2" />
            </span>
          </div>
        </Col>
      </Row>

      {/* Filter Card */}
      {showFilters && (
        <Row className="mb-3">
          <Col xs={12}>
            <div
              className="d-flex align-items-center justify-content-end gap-2 py-3 filter-card shadow-sm"
              style={{ zIndex: '100' }}
              ref={filterCardRef}
            >
              <div className="d-flex align-items-center justify-content-center flex-wrap gap-2">
                <FalseAlertFilters
                  maxWeek={getCurrentWeekWithYear()}
                  role={role}
                  selectedModule={newFilters?.selectedModule}
                  areas={areas}
                  subarea={subareas[newFilters?.area]}
                  cameras={cameras}
                  modulesforAlerts={modules}
                  handleDateDrop={handleDateDrop}
                  currentWeekk={currentWeek}
                  style={style}
                  handleNewInputChange={handleNewInputChange}
                  newFilters={newFilters}
                  selectedOption={selectedOption}
                  dateShow={dateShow}
                  monthShow={monthShow}
                  weeklyShow={weeklyShow}
                  customDate={customDate}
                  typeHeadFilter={true}
                  hideStatusFilter={true}
                />

                {showButtons && (
                  <div className="d-flex flex-wrap gap-2 justify-content-center">
                    <Button
                      style={style}
                      className="m-0 p-0 rounded-3 shadow-sm d-flex align-items-center justify-content-evenly"
                      onClick={applyNewFilters}
                      color=""
                    >
                      <IoCheckmarkOutline
                        style={{
                          color: '#22c65e',
                          fontSize: '20px',
                          transform: 'rotate(20deg)',
                        }}
                      />
                      <p style={{ color: '#22c65e' }} className="m-0 p-0">
                        Accept
                      </p>
                    </Button>
                    <Button
                      style={style}
                      className="m-0 p-0 rounded-3 shadow-sm d-flex align-items-center justify-content-evenly"
                      onClick={Reset}
                      color=""
                    >
                      <RxReset
                        style={{
                          color: '#4e74d4',
                          fontSize: '20px',
                        }}
                      />
                      <p style={{ color: '#4e74d4' }} className="m-0 p-0">
                        Reset
                      </p>
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      )}

      {/* Camera Filter */}
      <Row className="mb-3">
        <Col xs={12} className="d-flex justify-content-end gap-2">
          <TypeheadFilter
            id="camera_search_filter"
            typeheadStyle={typeheadStyle}
            selected={newFilters?.camera_id}
            shifts={cameras}
            placeholder={'Enter Camera ID'}
            handleTypeChange={handleTypeChange}
          />
          {showCamButton && (
            <Button
              style={{
                width: '100px',
                fontSize: '15px',
                color: 'black',
              }}
              className="m-0 p-0 rounded-3 shadow-sm d-flex align-items-center justify-content-evenly"
              onClick={applyNewFilters}
              color=""
            >
              <IoCheckmarkOutline
                style={{
                  color: '#22c65e',
                  fontSize: '20px',
                  transform: 'rotate(20deg)',
                }}
              />
              <p style={{ color: '#22c65e' }} className="m-0 p-0">
                Accept
              </p>
            </Button>
          )}
        </Col>
      </Row>

      {/* Transfer Images Card - Shows when cards are selected */}
      {selectedCards.length > 0 && (
        <Row className="mb-4">
          <Col xs={12}>
            <BootstrapCard className="shadow-sm" style={{ borderTop: '4px solid #007bff' }}>
              <CardBody>
                <h5 className="mb-3" style={{ color: '#007bff', fontWeight: 600 }}>
                  Transfer Images to Batch
                </h5>
                
                <p className="mb-3" style={{ color: '#007bff', fontSize: '14px', fontWeight: 500 }}>
                  Selected Images: {selectedCards.length} cards
                </p>

                <div className="mb-3">
                  <label className="form-label" style={{ fontWeight: 500 }}>
                    Select Batch*
                  </label>
                  {loadingBatches ? (
                    <div className="text-center py-2">
                      <Loader3 />
                    </div>
                  ) : (
                    <div style={{ position: 'relative' }} ref={batchDropdownRef}>
                      {/* Selected Batches Display */}
                      <div
                        onClick={() => setShowBatchDropdown(!showBatchDropdown)}
                        style={{
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          padding: '8px',
                          minHeight: '42px',
                          cursor: 'pointer',
                          backgroundColor: '#fff',
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '6px',
                          alignItems: 'center',
                        }}
                      >
                        {selectedBatch.length === 0 ? (
                          <span style={{ color: '#6c757d', fontSize: '14px' }}>
                            Select batches...
                          </span>
                        ) : (
                          getSelectedBatchDetails().map((batch) => (
                            <span
                              key={batch.batch_id}
                              style={{
                                backgroundColor: '#007bff',
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '13px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                              }}
                            >
                              Batch {batch.batch_id} - {batch.factory_name?.split(' ')[0]}
                              <X
                                size={14}
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveBatch(batch.batch_id);
                                }}
                              />
                            </span>
                          ))
                        )}
                      </div>

                      {/* Dropdown List */}
                      {showBatchDropdown && (
                        <div
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            backgroundColor: 'white',
                            border: '1px solid #ced4da',
                            borderRadius: '4px',
                            marginTop: '4px',
                            maxHeight: '250px',
                            overflowY: 'auto',
                            zIndex: 1000,
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                          }}
                        >
                          {batches.length === 0 ? (
                            <div style={{ padding: '12px', color: '#6c757d', fontSize: '14px' }}>
                              No batches available for this factory
                            </div>
                          ) : (
                            <>
                              {batches.map((batch) => (
                                <div
                                  key={batch.batch_id}
                                  onClick={() => handleBatchToggle(batch.batch_id)}
                                  style={{
                                    padding: '10px 12px',
                                    cursor: 'pointer',
                                    backgroundColor: selectedBatch.includes(batch.batch_id)
                                      ? '#e7f3ff'
                                      : 'white',
                                    borderBottom: '1px solid #f0f0f0',
                                    transition: 'background-color 0.2s',
                                  }}
                                  onMouseEnter={(e) => {
                                    if (!selectedBatch.includes(batch.batch_id)) {
                                      e.target.style.backgroundColor = '#f8f9fa';
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (!selectedBatch.includes(batch.batch_id)) {
                                      e.target.style.backgroundColor = 'white';
                                    }
                                  }}
                                >
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <input
                                      type="checkbox"
                                      checked={selectedBatch.includes(batch.batch_id)}
                                      onChange={() => {}}
                                      style={{ cursor: 'pointer' }}
                                    />
                                    <div>
                                      <div style={{ fontWeight: 500, fontSize: '14px' }}>
                                        Batch {batch.batch_id} - {batch.factory_name}
                                      </div>
                                      <div style={{ fontSize: '12px', color: '#6c757d' }}>
                                        Modules: {batch.modules.map((m) => m.name).join(', ')}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                              
                              {/* Done Button */}
                              {selectedBatch.length > 0 && (
                                <div
                                  style={{
                                    padding: '8px 12px',
                                    borderTop: '2px solid #e0e0e0',
                                    backgroundColor: '#f8f9fa',
                                    position: 'sticky',
                                    bottom: 0,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    animation: 'slideInUp 0.3s ease-out',
                                  }}
                                >
                                  <style>
                                    {`
                                      @keyframes slideInUp {
                                        from {
                                          transform: translateY(20px);
                                          opacity: 0;
                                        }
                                        to {
                                          transform: translateY(0);
                                          opacity: 1;
                                        }
                                      }
                                      @keyframes pulse {
                                        0%, 100% {
                                          transform: scale(1);
                                          box-shadow: 0 2px 4px rgba(0,123,255,0.3);
                                        }
                                        50% {
                                          transform: scale(1.05);
                                          box-shadow: 0 4px 8px rgba(0,123,255,0.5);
                                        }
                                      }
                                      .done-button-animated {
                                        animation: pulse 1.5s ease-in-out 2;
                                      }
                                    `}
                                  </style>
                                  <Button
                                    color="primary"
                                    size="sm"
                                    onClick={() => setShowBatchDropdown(false)}
                                    className="done-button-animated"
                                    style={{
                                      fontWeight: 600,
                                      fontSize: '13px',
                                      padding: '6px 20px',
                                      boxShadow: '0 2px 6px rgba(0,123,255,0.4)',
                                      transition: 'all 0.2s ease',
                                    }}
                                  >
                                    ✓ Done ({selectedBatch.length})
                                  </Button>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="d-flex align-items-center gap-2 mb-3">
                  <Button
                    color="info"
                    onClick={handleDryRun}
                    disabled={selectedBatch.length === 0 || dryRunning || transferring}
                    className="d-flex align-items-center gap-2"
                  >
                    {dryRunning ? 'Running Dry Run...' : 'Dry Run'}
                  </Button>
                  <Button
                    color="primary"
                    onClick={handleActualTransfer}
                    disabled={selectedBatch.length === 0 || transferring || dryRunning}
                    className="d-flex align-items-center gap-2"
                  >
                    {transferring ? 'Transferring...' : 'Transfer Images'}
                  </Button>
                </div>

                <div className="mt-3">
                  <small className="text-muted">
                    Please select at least one batch to transfer images. Use "Dry Run" to preview the transfer before committing.
                  </small>
                </div>

                {/* Bottom Info Section */}
                <div
                  className="mt-4 pt-3"
                  style={{
                    borderTop: '1px solid #e0e0e0',
                  }}
                >
                  <Row className="align-items-center">
                    <Col xs={12} md={6}>
                      <div className="d-flex align-items-center gap-3 flex-wrap mb-2 mb-md-0">
                        <span style={{ fontWeight: 600, color: '#007bff', fontSize: '14px' }}>
                          Total Images: {totalAlerts}
                        </span>
                        <span style={{ fontWeight: 600, fontSize: '14px' }}>
                          Current Page: {data.length} images
                        </span>
                        <span
                          style={{
                            backgroundColor: '#007bff',
                            color: 'white',
                            padding: '4px 12px',
                            borderRadius: '4px',
                            fontWeight: 600,
                            fontSize: '14px',
                          }}
                        >
                          Selected: {selectedCards.length}
                        </span>
                      </div>
                    </Col>
                    <Col xs={12} md={6} className="text-md-end">
                      <div className="d-flex justify-content-md-end gap-2">
                        <Button color="primary" size="sm" onClick={handleDeselectAll}>
                          Deselect All
                        </Button>
                        <Button color="danger" size="sm" onClick={handleDeselectAll}>
                          Clear all {selectedCards.length} cards
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </BootstrapCard>
          </Col>
        </Row>
      )}

      {/* Alert Cards Grid */}
      <Row>
        {data.length > 0 ? (
          data.map((alert) => (
            <Col key={alert.id} xs={12} sm={6} lg={4} xl={3} className="mb-3">
              <Card 
                alert={alert} 
                isSelected={selectedCards.includes(alert.id)}
                onSelect={handleCardSelect}
                onImageClick={handleImageClick}
              />
            </Col>
          ))
        ) : (
          <Col xs={12}>
            <div className="text-center p-5">
              <h5 className="text-muted">No false alerts found</h5>
            </div>
          </Col>
        )}
      </Row>

      {/* Pagination */}
      {totalPages > 1 && (
        <Row className="mt-4">
          <Col xs={12}>
            <div className="d-flex justify-content-center align-items-center gap-2">
              <Button
                color="primary"
                size="sm"
                disabled={pageNo === 1}
                onClick={() => setPageNo(1)}
              >
                First
              </Button>
              <Button
                color="primary"
                size="sm"
                disabled={pageNo === 1}
                onClick={() => setPageNo((prev) => prev - 1)}
              >
                Previous
              </Button>
              <span className="mx-3">
                Page {pageNo} of {totalPages}
              </span>
              <Button
                color="primary"
                size="sm"
                disabled={pageNo === totalPages}
                onClick={() => setPageNo((prev) => prev + 1)}
              >
                Next
              </Button>
              <Button
                color="primary"
                size="sm"
                disabled={pageNo === totalPages}
                onClick={() => setPageNo(totalPages)}
              >
                Last
              </Button>
            </div>
          </Col>
        </Row>
      )}

      {/* Dry Run Modal */}
      <DryRunModal
        isOpen={showDryRunModal}
        toggle={() => setShowDryRunModal(false)}
        dryRunData={dryRunData}
        onTransfer={handleActualTransfer}
        transferring={transferring}
      />

      {/* Image Zoom Modal */}
      {showImageZoom && selectedImage && (
        <ImageZoom
          photo={selectedImage.photo}
          setIsOpen={setShowImageZoom}
          setShowModal={setShowImageZoom}
          imageData={{
            cameraName: selectedImage.cameraName,
            violation: selectedImage.violation,
            date: selectedImage.date,
            LSR: selectedImage.LSR,
            location: selectedImage.location,
            reportedBy: selectedImage.reportedBy,
          }}
          cameraTable={false}
        />
      )}
    </Container>
  );
};

export default FalseAlert;
